// hooks/useAppointmentDetails.js
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getUserFromToken, getStaffFromToken } from "src/DecodeToken";
import storage from "src/utils/storageUtils";

const useAppointmentDetails = () => {
    const params = useParams() || {};
    const appointmentData = useSelector((state) => state.app.tokenAppointmentsById);
    const selectedPatient = useSelector((state) => state.app.selectedPatient);
    const patientById = useSelector((state) => state.app.patientById);
    const clinicData = useSelector((state) => state.app.clinics);
    const appointmentDetails = appointmentData?.payload?.data?.tokenappointment || appointmentData?.data?.tokenappointment || appointmentData?.tokenappointment || {};
    
    let parsedSelected = null;
    try {
        const storedSelected = storage.get('SELECTED_PATIENT');
        if (storedSelected) parsedSelected = JSON.parse(storedSelected);
    } catch (e) {
        parsedSelected = null;
    }

    let parsedClinic = null;
    try {
        const storedClinic = localStorage.getItem('selectedClinic');
        if (storedClinic) parsedClinic = JSON.parse(storedClinic);
    } catch (e) {
        parsedClinic = null;
    }

    let PatientId = appointmentDetails.patient?.id || appointmentDetails.patient?._id || appointmentDetails.patient;
    if (typeof PatientId === 'object' && PatientId !== null) {
        PatientId = PatientId.id || PatientId._id || null;
    }
    PatientId =
        PatientId ||
        selectedPatient?.payload?.id ||
        selectedPatient?.payload?.patientId ||
        patientById?.payload?.data?.patient?.id ||
        patientById?.payload?.data?.patient?._id ||
        params.patientId ||
        storage.get('PATIENT_ID') ||
        parsedSelected?.patientId ||
        parsedSelected?.id ||
        null;

    let user = getUserFromToken() || getStaffFromToken()?.doctor || storage.get('DOCTOR_ID') || parsedClinic?.doctor || null;

    let clinicId = appointmentDetails.clinic?.id || appointmentDetails.clinic?._id || appointmentDetails.clinic;
    if (typeof clinicId === 'object' && clinicId !== null) {
        clinicId = clinicId.id || clinicId._id || clinicId?.[0]?.id || clinicId?.[0]?._id || null;
    }
    clinicId =
        clinicId ||
        clinicData?.clinicId ||
        clinicData?.currentClinic?.id ||
        storage.get('CLINIC_ID') ||
        parsedClinic?.id ||
        parsedClinic?._id ||
        null;

    const appointmentId =
        appointmentDetails.id ||
        appointmentDetails._id ||
        params.appointmentId ||
        parsedSelected?.appointmentId ||
        null;

    return { appointmentDetails, PatientId, user, clinicId, appointmentId };
};

export default useAppointmentDetails;

